<template>
  <div class="vsl-row vsl-color-picker">
    <h5 class="label">
      {{ label }}
      <a
        v-if="basicSelection"
        class="btn btn-link btn-sm"
        v-on:click="handleAdvancedSelectionClicked()"
        >{{ $t('ui.vertical_scroll_layout.advanced_selection_label') }}</a
      >
      <a
        v-if="!basicSelection"
        class="btn btn-link btn-sm"
        v-on:click="handleBasicSelectionClicked()"
        >{{ $t('ui.vertical_scroll_layout.basic_selection_label') }}</a
      >
    </h5>
    <compact-picker v-if="basicSelection" class="basic-color-picker-control" v-model="colors" />
    <chrome-picker v-if="!basicSelection" class="advanced-color-picker-control" v-model="colors" />
  </div>
</template>

<script>
import chrome from 'vue-color/src/components/Chrome.vue';
import compact from 'vue-color/src/components/Compact.vue';

export default {
  name: 'VSLColorPickerRowRenderer',

  components: {
    'chrome-picker': chrome,
    'compact-picker': compact,
  },

  props: {
    type: String,
    label: String,
    value: String,
  },

  data() {
    return {
      basicSelection: true,
      colors: '#000000',
    };
  },

  methods: {
    handleAdvancedSelectionClicked() {
      this.basicSelection = !this.basicSelection;
    },

    handleBasicSelectionClicked() {
      this.basicSelection = !this.basicSelection;
    },
  },

  watch: {
    colors: function () {
      if (this.colors.hex) {
        this.$emit('input', this.colors.hex);
        console.log(this.colors.hex);
      }
    },

    model: function () {
      console.log('model changed');
      this.colors = this.model;
    },
  },

  mounted() {
    if (this.value) {
      this.colors = this.value;
    }
  },
};
</script>

<style scoped>
.basic-color-picker-control {
  box-shadow: none;
  margin: 0 auto;
  width: 50%;
}

.advanced-color-picker-control {
  display: grid;
  grid-template-columns: 40% 60%;
  grid-template-rows: auto;
  grid-template-areas: 'body wrap';
  box-shadow: none;
  margin: 0 auto;
  width: 100%;
}
</style>

<style>
.vsl-color-picker .btn-link {
  text-decoration: none;
}

.vc-chrome-body {
  grid-area: body;
}

.vc-chrome-saturation-wrap {
  grid-area: wrap;
}

.vc-chrome-color-wrap {
  width: 58px;
}

.vc-chrome-active-color {
  width: 50px;
  height: 50px;
}

.vc-chrome-color-wrap .vc-checkerboard {
  width: 50px;
  height: 50px;
}

.vc-compact .vc-compact-color-item {
  width: 40px;
  height: 40px;
}
</style>
